import { lazy } from 'react';

// project-imports
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import WidgetStatistics from 'pages/widget/statistics';
import WidgetData from 'pages/widget/data';
import WidgetChart from 'pages/widget/chart';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const DashboardAnalytics = Loadable(lazy(() => import('pages/dashboard/analytics')));

// render - widget

// render - applications
// const AppChat = Loadable(lazy(() => import('pages/apps/chat')));
const AppBees = Loadable(lazy(() => import('pages/apps/Bees_old/list')));
const AppCity = Loadable(lazy(() => import('pages/apps/city/list')));
const AppVendor = Loadable(lazy(() => import('pages/apps/vendor/list')));
const Purchase = Loadable(lazy(() => import('pages/apps/purchase/list')));
const AppCalendar = Loadable(lazy(() => import('pages/apps/calendar')));

const AppKanban = Loadable(lazy(() => import('pages/apps/kanban')));
const AppKanbanBacklogs = Loadable(lazy(() => import('sections/apps/kanban/Backlogs')));
const AppKanbanBoard = Loadable(lazy(() => import('sections/apps/kanban/Board')));

const AppCustomerList = Loadable(lazy(() => import('pages/apps/customer/list')));
const AppCustomerCard = Loadable(lazy(() => import('pages/apps/customer/card')));

const AppInvoiceCreate = Loadable(lazy(() => import('pages/apps/invoice/create')));
const AppInvoiceDashboard = Loadable(lazy(() => import('pages/apps/invoice/dashboard')));
const AppInvoiceList = Loadable(lazy(() => import('pages/apps/invoice/list')));
const AppInvoiceDetails = Loadable(lazy(() => import('pages/apps/invoice/details')));
const AppInvoiceEdit = Loadable(lazy(() => import('pages/apps/invoice/edit')));

const AppPoCreate = Loadable(lazy(() => import('pages/apps/po/create')));
const AppPoDashboard = Loadable(lazy(() => import('pages/apps/po/dashboard')));
const AppPoList = Loadable(lazy(() => import('pages/apps/po/list')));
const AppPoDetails = Loadable(lazy(() => import('pages/apps/po/details')));
const AppPoEdit = Loadable(lazy(() => import('pages/apps/po/edit')));

const UserProfile = Loadable(lazy(() => import('pages/apps/profiles/user')));
const UserTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/user/TabPersonal')));
const UserTabPayment = Loadable(lazy(() => import('sections/apps/profiles/user/TabPayment')));
const UserTabPassword = Loadable(lazy(() => import('sections/apps/profiles/user/TabPassword')));
const UserTabSettings = Loadable(lazy(() => import('sections/apps/profiles/user/TabSettings')));

const AccountProfile = Loadable(lazy(() => import('pages/apps/profiles/account')));
const AccountTabProfile = Loadable(lazy(() => import('sections/apps/profiles/account/TabProfile')));
const AccountTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/account/TabPersonal')));
const AccountTabAccount = Loadable(lazy(() => import('sections/apps/profiles/account/TabAccount')));
const AccountTabPassword = Loadable(lazy(() => import('sections/apps/profiles/account/TabPassword')));
const AccountTabRole = Loadable(lazy(() => import('sections/apps/profiles/account/TabRole')));
const AccountTabSettings = Loadable(lazy(() => import('sections/apps/profiles/account/TabSettings')));

const AppECommProducts = Loadable(lazy(() => import('pages/apps/e-commerce/product')));
const AppECommProductDetails = Loadable(lazy(() => import('pages/apps/e-commerce/product-details')));
const AppECommProductList = Loadable(lazy(() => import('pages/apps/e-commerce/products-list')));
const AppECommCheckout = Loadable(lazy(() => import('pages/apps/e-commerce/checkout')));
const AppECommAddProduct = Loadable(lazy(() => import('pages/apps/e-commerce/add-product')));

const AppGroxProducts = Loadable(lazy(() => import('pages/apps/Products/product')));
const AppGroxProductDetails = Loadable(lazy(() => import('pages/apps/Products/product-details')));
const AppGroxProductList = Loadable(lazy(() => import('pages/apps/Products/products-list')));
const AppGroxCheckout = Loadable(lazy(() => import('pages/apps/Products/checkout')));
const AppGroxAddProduct = Loadable(lazy(() => import('pages/apps/Products/addNewProduct')));
const AppGroxWholeSaleProductList = Loadable(lazy(() => import('pages/apps/Products/whole-sale-product-list')));
const AppGroxAddWholeSaleProduct = Loadable(lazy(() => import('pages/apps/Products/addNewWholeSaleProduct')));

const AppGroxAddRelatedProduct = Loadable(lazy(() => import('pages/apps/Related-Products/addRelatedProduct')));
const AppGroxRelatedProductList = Loadable(lazy(() => import('pages/apps/Related-Products/related-products-list')));


const AppGroxProductNutritionList = Loadable(lazy(() => import('pages/apps/Nutrition/nutrition-list')));
const AppGroxAddProductNutrition = Loadable(lazy(() => import('pages/apps/Nutrition/add-new-product-nutrition')));

const AppGroxCategoryList = Loadable(lazy(() => import('pages/apps/category/category-list')));
const AppGroxAddCategory = Loadable(lazy(() => import('pages/apps/category/add-new-category')));

const AppGroxPromocodeList = Loadable(lazy(() => import('pages/apps/promocode/promocode-list')));
const AppGroxAddPromocode = Loadable(lazy(() => import('pages/apps/promocode/add-new-promocode')));

const AppGroxVendorList = Loadable(lazy(() => import('pages/apps/vendors/vendor-list')));
const AppGroxAddVendor = Loadable(lazy(() => import('pages/apps/vendors/add-new-vendor')));

const AppGroxSponsorList = Loadable(lazy(() => import('pages/apps/sponsors/sponsor-list')));
const AppGroxAddSponsor = Loadable(lazy(() => import('pages/apps/sponsors/add-new-sponsor')));

const AppGroxBPAdminList = Loadable(lazy(() => import('pages/apps/beesPerformance/beesPerformance-admin-list')));
const AppGroxAddBpAdmin = Loadable(lazy(() => import('pages/apps/beesPerformance/add-new-bp-admin')));

const AppGroxTrainingList = Loadable(lazy(() => import('pages/apps/training/training-list')));
const AppGroxAddTraining = Loadable(lazy(() => import('pages/apps/training/add-new-training')));
const AppGroxTrainingAttendanceList = Loadable(lazy(() => import('pages/apps/training/trainingAttendance-list')));
const AppGroxAddTrainingAttendance = Loadable(lazy(() => import('pages/apps/training/add-new-trainingAttendance')));

const AppGroxCampaignList = Loadable(lazy(() => import('pages/apps/campaign/campaign-list')));
const AppGroxAddCampaign = Loadable(lazy(() => import('pages/apps/campaign/add-new-campaign')));

const AppGroxCreditList = Loadable(lazy(() => import('pages/apps/credits/credit-list')));
const AppGroxAddCredit = Loadable(lazy(() => import('pages/apps/credits/add-new-credit')));

const AppGroxInventoryList = Loadable(lazy(() => import('pages/apps/inventory/inventory-list')));
const AppGroxInventoryDetails = Loadable(lazy(() => import('pages/apps/inventory/inventory-details')));
const AppGroxAddInventory = Loadable(lazy(() => import('pages/apps/inventory/add-new-inventory')));

const AppGroxInventoryPackList = Loadable(lazy(() => import('pages/apps/inventory-pack/inventory-pack-list')));
const AppGroxAddInventoryPack = Loadable(lazy(() => import('pages/apps/inventory-pack/add-new-inventory-pack')));

const AppGroxAddGRN = Loadable(lazy(() => import('pages/apps/grn/add-new-grn')));
const AppGroxGRNList = Loadable(lazy(() => import('pages/apps/grn/grn-list')));

const AppGroxAddUser = Loadable(lazy(() => import('pages/apps/user/add-new-user')));
const AppGroxUserList = Loadable(lazy(() => import('pages/apps/user/user-list')));

const AppGroxAddRole = Loadable(lazy(() => import('pages/apps/role/add-new-role')));
const AppGroxRoleList = Loadable(lazy(() => import('pages/apps/role/role-list')));

const AppGroxAddScreen = Loadable(lazy(() => import('pages/apps/screen_page/add-new-screen')));
const AppGroxScreensList = Loadable(lazy(() => import('pages/apps/screen_page/screens-list')));

const AppGroxAddSubScreen = Loadable(lazy(() => import('pages/apps/sub_screen_page/add-new-sub-screen')));
const AppGroxSubScreensList = Loadable(lazy(() => import('pages/apps/sub_screen_page/sub-screens-list')));

const AppGroxAddQualityCheck = Loadable(lazy(() => import('pages/apps/quality_check/add-new-quality_check')));
const AppGroxAddNewStock = Loadable(lazy(() => import('pages/apps/quality_check/add-new-stock')));
const AppGroxQualityCheckList = Loadable(lazy(() => import('pages/apps/quality_check/quality_check-list')));

const AppGroxFlavorsList = Loadable(lazy(() => import('pages/apps/flavors/recipe-list')));
const AppGroxAddFlavors = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipe')));
const AppGroxRecipeTagsList = Loadable(lazy(() => import('pages/apps/flavors/recipe-tags-list')));
const AppGroxAddFlavorsCategory = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipeTags')));
const AppGroxRecipeGroupList = Loadable(lazy(() => import('pages/apps/flavors/recipe-group-list')));
const AppGroxAddFlavorsGroup = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipeGroup')));
const AppGroxRecipeBannersList = Loadable(lazy(() => import('pages/apps/flavors/recipeBanners-list')));
const AppGroxAddRecipeBanners = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipeBanners')));
const AppGroxRecipeSlidersList = Loadable(lazy(() => import('pages/apps/flavors/recipeSlider-list')));
const AppGroxAddRecipeSliders = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipeSlider')));

const AppGroxRecipeSuitabilityList = Loadable(lazy(() => import('pages/apps/flavors/recipe-suitability-list')));
const AppGroxAddRecipeSuitability = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipeSuitability')));

const AppGroxMealTypeList = Loadable(lazy(() => import('pages/apps/flavors/meal-type-list')));
const AppGroxAddMealType = Loadable(lazy(() => import('pages/apps/flavors/add-new-mealType')));

const AppGroxRecipeCuisineList = Loadable(lazy(() => import('pages/apps/flavors/recipe-cuisine-list')));
const AppGroxAddRecipeCuisine = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipeCuisine')));

const AppGroxRecipeNutritionList = Loadable(lazy(() => import('pages/apps/flavors/recipe-keyword-list')));
const AppGroxAddRecipeNutrition = Loadable(lazy(() => import('pages/apps/flavors/add-new-recipe-Keyword')));

const AppGroxBannersList = Loadable(lazy(() => import('pages/apps/banners/banners-list')));
const AppGroxAddBanners = Loadable(lazy(() => import('pages/apps/banners/add-new-Banners')));
const AppGroxSlidersList = Loadable(lazy(() => import('pages/apps/banners/slider-list')));
const AppGroxAddSliders = Loadable(lazy(() => import('pages/apps/banners/add-new-slider')));

const AppGroxPurchaseList = Loadable(lazy(() => import('pages/apps/purchase1/purchase-list')));
const AppGroxAddPurchase = Loadable(lazy(() => import('pages/apps/purchase1/add-new-purchase')));
const AppGroxWholeSalePurchaseList = Loadable(lazy(() => import('pages/apps/purchase1/whole-sale-purchase-list')));
const AppGroxAddWholeSalePurchase = Loadable(lazy(() => import('pages/apps/purchase1/add-new-whole-sale-purchase')));
const AppGroxUpdatePurchaseProduct = Loadable(lazy(() => import('pages/apps/purchase1/update-price')));

const AppGroxOrderList = Loadable(lazy(() => import('pages/apps/orders/orders-list')));
const AppGroxOrderReturnList = Loadable(lazy(() => import('pages/apps/return/return-list')));


const AppGroxBeesList = Loadable(lazy(() => import('pages/apps/bees/bees-list')));
const AppGroxAddBees = Loadable(lazy(() => import('pages/apps/bees/AddNewBees')));

const AppGroxStaffList = Loadable(lazy(() => import('pages/apps/staff/staff-list')));
const AppGroxAddStaff = Loadable(lazy(() => import('pages/apps/staff/AddNewStaff')));

const AppGroxNotificationList = Loadable(lazy(() => import('pages/apps/notification/notification-list')));
const AppGroxAddNotification = Loadable(lazy(() => import('pages/apps/notification/AddNewNotification')));

const AppGroxCompanyList = Loadable(lazy(() => import('pages/apps/company/company-list')));
const AppGroxAddCompany = Loadable(lazy(() => import('pages/apps/company/AddNewCompany')));

const AppGroxCompanyBankList = Loadable(lazy(() => import('pages/apps/company/company-bank-list')));
const AppGroxAddBank = Loadable(lazy(() => import('pages/apps/company/AddBank')));

const AppGroxHomeScreenComponentList = Loadable(lazy(() => import('pages/apps/homeScreen/home-components-list')));
const AppGroxAddHomeScreenComponent = Loadable(lazy(() => import('pages/apps/homeScreen/AddHomeScreenComponent')));
const AppGroxHomeScreenImageList = Loadable(lazy(() => import('pages/apps/homeScreen/homeScreen-images-list')));
const AppGroxAddHomeScreenImage = Loadable(lazy(() => import('pages/apps/homeScreen/AddHomeScreenImage')));

const AppGroxFlavorScreenComponentList = Loadable(lazy(() => import('pages/apps/flavor/flavor-components-list')));
const AppGroxAddFlavorScreenComponent = Loadable(lazy(() => import('pages/apps/flavor/AddFlavorScreenComponent')));
// const AppGroxHomeScreenImageList = Loadable(lazy(() => import('pages/apps/flavor/flavorScreen-images-list')));
// const AppGroxAddHomeScreenImage = Loadable(lazy(() => import('pages/apps/homeScreen/AddHomeScreenImage')));

const AppGroxHomeComponentItemList = Loadable(lazy(() => import('pages/apps/homeScreen/home-components-itemList')));
const AppGroxHomeComponentItem = Loadable(lazy(() => import('pages/apps/homeScreen/AddNewHomeComponentItem')));
const AppGroxAddComponentToLayout = Loadable(lazy(() => import('pages/apps/homeScreen/AddComponentToLayout')));

const AppFlavorHomeComponentItemList = Loadable(lazy(() => import('pages/apps/flavor/flavor-components-itemList')));
const AppFlavorHomeComponentItem = Loadable(lazy(() => import('pages/apps/flavor/AddNewFlavorComponentItem')));
const AppFlavorAddComponentToLayout = Loadable(lazy(() => import('pages/apps/flavor/AddFlavorComponentToLayout')));

const AppGroxFilterList = Loadable(lazy(() => import('pages/apps/filter/filter-list')));
const AppGroxAddFilter = Loadable(lazy(() => import('pages/apps/filter/add-new-filter')));

const AppGroxFilterGroupList = Loadable(lazy(() => import('pages/apps/filter/filterGroup-list')));
const AppGroxAddFilterGroup = Loadable(lazy(() => import('pages/apps/filter/add-new-filterGroup')));

// render - forms & tables
const FormsValidation = Loadable(lazy(() => import('pages/forms/validation')));
const FormsWizard = Loadable(lazy(() => import('pages/forms/wizard')));

const FormsLayoutBasic = Loadable(lazy(() => import('pages/forms/layouts/basic')));
const FormsLayoutMultiColumn = Loadable(lazy(() => import('pages/forms/layouts/multi-column')));
const FormsLayoutActionBar = Loadable(lazy(() => import('pages/forms/layouts/action-bar')));
const FormsLayoutStickyBar = Loadable(lazy(() => import('pages/forms/layouts/sticky-bar')));

const FormsPluginsMask = Loadable(lazy(() => import('pages/forms/plugins/mask')));
const FormsPluginsClipboard = Loadable(lazy(() => import('pages/forms/plugins/clipboard')));
const FormsPluginsRecaptcha = Loadable(lazy(() => import('pages/forms/plugins/re-captcha')));
const FormsPluginsEditor = Loadable(lazy(() => import('pages/forms/plugins/editor')));
const FormsPluginsDropzone = Loadable(lazy(() => import('pages/forms/plugins/dropzone')));

const ReactTableBasic = Loadable(lazy(() => import('pages/tables/react-table/basic')));
const ReactTableSorting = Loadable(lazy(() => import('pages/tables/react-table/sorting')));
const ReactTableFiltering = Loadable(lazy(() => import('pages/tables/react-table/filtering')));
const ReactTableGrouping = Loadable(lazy(() => import('pages/tables/react-table/grouping')));
const ReactTablePagination = Loadable(lazy(() => import('pages/tables/react-table/pagination')));
const ReactTableRowSelection = Loadable(lazy(() => import('pages/tables/react-table/row-selection')));
const ReactTableExpanding = Loadable(lazy(() => import('pages/tables/react-table/expanding')));
const ReactTableEditable = Loadable(lazy(() => import('pages/tables/react-table/editable')));
const ReactTableDragDrop = Loadable(lazy(() => import('pages/tables/react-table/drag-drop')));
const ReactTableColumnHiding = Loadable(lazy(() => import('pages/tables/react-table/column-hiding')));
const ReactTableColumnResizing = Loadable(lazy(() => import('pages/tables/react-table/column-resizing')));
const ReactTableStickyTable = Loadable(lazy(() => import('pages/tables/react-table/sticky')));
const ReactTableUmbrella = Loadable(lazy(() => import('pages/tables/react-table/umbrella')));
const ReactTableEmpty = Loadable(lazy(() => import('pages/tables/react-table/empty')));

// render - charts & map
const ChartApexchart = Loadable(lazy(() => import('pages/charts/apexchart')));
const ChartOrganization = Loadable(lazy(() => import('pages/charts/org-chart')));

// table routing
const MuiTableBasic = Loadable(lazy(() => import('pages/tables/mui-table/basic')));
const MuiTableDense = Loadable(lazy(() => import('pages/tables/mui-table/dense')));
const MuiTableEnhanced = Loadable(lazy(() => import('pages/tables/mui-table/enhanced')));
const MuiTableDatatable = Loadable(lazy(() => import('pages/tables/mui-table/datatable')));
const MuiTableCustom = Loadable(lazy(() => import('pages/tables/mui-table/custom')));
const MuiTableFixedHeader = Loadable(lazy(() => import('pages/tables/mui-table/fixed-header')));
const MuiTableCollapse = Loadable(lazy(() => import('pages/tables/mui-table/collapse')));

// pages routing
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const PricingPage = Loadable(lazy(() => import('pages/extra-pages/pricing')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'dashboard',
          children: [
            {
              path: 'default',
              element: <DashboardDefault />
            },
            {
              path: 'analytics',
              element: <DashboardAnalytics />
            }
          ]
        },
        {
          path: 'widget',
          children: [
            {
              path: 'statistics',
              element: <WidgetStatistics />
            },
            {
              path: 'data',
              element: <WidgetData />
            },
            {
              path: 'chart',
              element: <WidgetChart />
            }
          ]
        },

        {
          path: 'apps',
          children: [
            // {
            //   path: 'chat',
            //   element: <AppChat />
            // },
            {
              path: 'bees',
              element: <AppBees />
            },
            {
              path: 'city',
              element: <AppCity />
            },
            {
              path: 'vendor',
              element: <AppVendor />
            },
            {
              path: 'purchase',
              element: <Purchase />
            },

            {
              path: 'calendar',
              element: <AppCalendar />
            },
            {
              path: 'kanban',
              element: <AppKanban />,
              children: [
                {
                  path: 'backlogs',
                  element: <AppKanbanBacklogs />
                },
                {
                  path: 'board',
                  element: <AppKanbanBoard />
                }
              ]
            },
            {
              path: 'customer',
              children: [
                {
                  path: 'customer-list',
                  element: <AppCustomerList />
                },
                {
                  path: 'customer-card',
                  element: <AppCustomerCard />
                }
              ]
            },
            {
              path: 'invoice',
              children: [
                {
                  path: 'dashboard',
                  element: <AppInvoiceDashboard />
                },
                {
                  path: 'create',
                  element: <AppInvoiceCreate />
                },
                {
                  path: 'details/:id',
                  element: <AppInvoiceDetails />
                },
                {
                  path: 'edit/:id',
                  element: <AppInvoiceEdit />
                },
                {
                  path: 'list',
                  element: <AppInvoiceList />
                }
              ]
            },
            {
              path: 'po',
              children: [
                {
                  path: 'dashboard',
                  element: <AppPoDashboard />
                },
                {
                  path: 'create',
                  element: <AppPoCreate />
                },
                {
                  path: 'details/:id',
                  element: <AppPoDetails />
                },
                {
                  path: 'edit/:id',
                  element: <AppPoEdit />
                },
                {
                  path: 'list',
                  element: <AppPoList />
                }
              ]
            },
            {
              path: 'profiles',
              children: [
                {
                  path: 'account',
                  element: <AccountProfile />,
                  children: [
                    {
                      path: 'basic',
                      element: <AccountTabProfile />
                    },
                    {
                      path: 'personal',
                      element: <AccountTabPersonal />
                    },
                    {
                      path: 'my-account',
                      element: <AccountTabAccount />
                    },
                    {
                      path: 'password',
                      element: <AccountTabPassword />
                    },
                    {
                      path: 'role',
                      element: <AccountTabRole />
                    },
                    {
                      path: 'settings',
                      element: <AccountTabSettings />
                    }
                  ]
                },
                {
                  path: 'user',
                  element: <UserProfile />,
                  children: [
                    {
                      path: 'personal',
                      element: <UserTabPersonal />
                    },
                    {
                      path: 'payment',
                      element: <UserTabPayment />
                    },
                    {
                      path: 'password',
                      element: <UserTabPassword />
                    },
                    {
                      path: 'settings',
                      element: <UserTabSettings />
                    }
                  ]
                }
              ]
            },
            {
              path: 'e-commerce',
              children: [
                {
                  path: 'products',
                  element: <AppECommProducts />
                },
                {
                  path: 'product-details/:id',
                  element: <AppECommProductDetails />
                },
                {
                  path: 'product-list',
                  element: <AppECommProductList />
                },
                {
                  path: 'add-new-product',
                  element: <AppECommAddProduct />
                },
                {
                  path: 'checkout',
                  element: <AppECommCheckout />
                }
              ]
            },
            {
              path: 'Products',
              children: [
                {
                  path: 'products',
                  element: <AppGroxProducts />
                },
                {
                  path: 'product-details/:id',
                  element: <AppGroxProductDetails />
                },
                {
                  path: 'product-list',
                  element: <AppGroxProductList />
                },
                {
                  path: 'add-new-product',
                  element: <AppGroxAddProduct />
                },
                {
                  path: 'whole-sale-product-list',
                  element: <AppGroxWholeSaleProductList />
                },
                {
                  path: 'add-new-whole-sale-product',
                  element: <AppGroxAddWholeSaleProduct />
                },
                {
                  path: 'checkout',
                  element: <AppGroxCheckout />
                }
              ]
            },
            {
              path: 'Related-Products',
              children: [
              
                {
                  path: 'related-products-list',
                  element: <AppGroxRelatedProductList />
                },
                {
                  path: 'addRelatedProduct',
                  element: <AppGroxAddRelatedProduct />
                },
             
              ]
            },
            {
              path: 'Nutrition',
              children: [
                {
                  path: 'nutrition-list',
                  element: <AppGroxProductNutritionList />
                },
                {
                  path: 'add-new-product-nutrition',
                  element: <AppGroxAddProductNutrition />
                }
              ]
            },
            {
              path: 'orders',  
              children: [
                {
                  path: 'orders-list',
                  element: <AppGroxOrderList />
                },
                {
                  path: 'add-new-category',
                  element: <AppGroxAddCategory />
                }
              ]
            },
            {
              path: 'return',
              children: [
                {
                  path: 'return-list',
                  element: <AppGroxOrderReturnList />
                },
                {
                  path: 'add-new-category',
                  element: <AppGroxAddCategory />
                }
              ]
            },
            {
              path: 'category',
              children: [
                {
                  path: 'category-list',
                  element: <AppGroxCategoryList />
                },
                {
                  path: 'add-new-category',
                  element: <AppGroxAddCategory />
                }
              ]
            },
            {
              path: 'promocode',
              children: [
                {
                  path: 'promocode-list',
                  element: <AppGroxPromocodeList />
                },
                {
                  path: 'add-new-promocode',
                  element: <AppGroxAddPromocode />
                }
              ]
            },
            {
              path: 'vendors',
              children: [
                {
                  path: 'vendor-list',
                  element: <AppGroxVendorList />
                },
                {
                  path: 'add-new-vendor',
                  element: <AppGroxAddVendor />
                }
              ]
            },
            {
              path: 'sponsors',
              children: [
                {
                  path: 'sponsor-list',
                  element: <AppGroxSponsorList />
                },
                {
                  path: 'add-new-sponsor',
                  element: <AppGroxAddSponsor />
                }
              ]
            },
            {
              path: 'beesPerformance',
              children: [
                {
                  path: 'beesPerformance-admin-list',
                  element: <AppGroxBPAdminList />
                },
                {
                  path: 'add-new-bp-admin',
                  element: <AppGroxAddBpAdmin />
                }
              ]
            },
            {
              path: 'training',
              children: [
                {
                  path: 'training-list',
                  element: <AppGroxTrainingList />
                },
                {
                  path: 'add-new-training',
                  element: <AppGroxAddTraining />
                },
                {
                  path: 'trainingAttendance-list',
                  element: <AppGroxTrainingAttendanceList />
                },
                {
                  path: 'add-new-trainingAttendance',
                  element: <AppGroxAddTrainingAttendance />
                },
              ]
            },
            {
              path: 'campaign',
              children: [
                {
                  path: 'campaign-list',
                  element: <AppGroxCampaignList />
                },
                {
                  path: 'add-new-campaign',
                  element: <AppGroxAddCampaign />
                }
              ]
            },
            {
              path: 'credits',
              children: [
                {
                  path: 'credit-list',
                  element: <AppGroxCreditList />
                },
                {
                  path: 'add-new-credit',
                  element: <AppGroxAddCredit />
                }
              ]
            },
            {
              path: 'inventory',
              children: [
                {
                  path: 'inventory-list',
                  element: <AppGroxInventoryList />
                },
                {
                  path: 'inventory-details',
                  element: <AppGroxInventoryDetails />
                },
                {
                  path: 'add-new-inventory',
                  element: <AppGroxAddInventory />
                }
              ]
            },
            {
              path: 'grn',
              children: [
                {
                  path: 'grn-list',
                  element: <AppGroxGRNList />
                },
                {
                  path: 'add-new-grn',
                  element: <AppGroxAddGRN />
                }
              ]
            },
            {
              path: 'user',
              children: [
                {
                  path: 'user-list',
                  element: <AppGroxUserList />
                },
                {
                  path: 'add-new-user',
                  element: <AppGroxAddUser />
                }
              ]
            },
            {
              path: 'role',
              children: [
                {
                  path: 'role-list',
                  element: <AppGroxRoleList />
                },
                {
                  path: 'add-new-role',
                  element: <AppGroxAddRole />
                }
              ]
            },
            {
              path: 'screen_page',
              children: [
                {
                  path: 'screens-list',
                  element: <AppGroxScreensList />
                },
                {
                  path: 'add-new-screen',
                  element: <AppGroxAddScreen />
                }
              ]
            },
            {
              path: 'sub_screen_page',
              children: [
                {
                  path: 'sub-screens-list',
                  element: <AppGroxSubScreensList />
                },
                {
                  path: 'add-new-sub-screen',
                  element: <AppGroxAddSubScreen />
                }
              ]
            },
            {
              path: 'quality_check',
              children: [
                {
                  path: 'quality_check-list',
                  element: <AppGroxQualityCheckList />
                },
                {
                  path: 'add-new-quality_check',
                  element: <AppGroxAddQualityCheck />
                },
                {
                  path: 'add-new-stock',
                  element: <AppGroxAddNewStock />
                }
              ]
            },
            {
              path: 'inventory-pack',
              children: [
                {
                  path: 'inventory-pack-list',
                  element: <AppGroxInventoryPackList />
                },
                {
                  path: 'add-new-inventory-pack',
                  element: <AppGroxAddInventoryPack />
                }
              ]
            },
            {
              path: 'banners',
              children: [
                {
                  path: 'banners-list',
                  element: <AppGroxBannersList />
                },
                {
                  path: 'add-new-Banners',
                  element: <AppGroxAddBanners />
                },
                {
                  path: 'slider-list',
                  element: <AppGroxSlidersList />
                },
                {
                  path: 'add-new-slider',
                  element: <AppGroxAddSliders />
                }
              ]
            },
            {
              path: 'flavors',
              children: [
                {
                  path: 'recipe-list',
                  element: <AppGroxFlavorsList />
                },
                {
                  path: 'add-new-recipe',
                  element: <AppGroxAddFlavors />
                },
                {
                  path: 'recipe-tags-list',
                  element: <AppGroxRecipeTagsList />
                },
                {
                  path: 'add-new-recipeTags',
                  element: <AppGroxAddFlavorsCategory />
                },
                {
                  path: 'recipe-group-list',
                  element: <AppGroxRecipeGroupList />
                },
                {
                  path: 'add-new-recipeGroup',
                  element: <AppGroxAddFlavorsGroup />
                },
                {
                  path: 'recipe-suitability-list',
                  element: <AppGroxRecipeSuitabilityList />
                },
                {
                  path: 'add-new-recipeSuitability',
                  element: <AppGroxAddRecipeSuitability />
                },
                {
                  path: 'meal-type-list',
                  element: <AppGroxMealTypeList />
                },
                {
                  path: 'add-new-mealType',
                  element: <AppGroxAddMealType />
                },
                {
                  path: 'recipe-cuisine-list',
                  element: <AppGroxRecipeCuisineList />
                },
                {
                  path: 'add-new-recipeCuisine',
                  element: <AppGroxAddRecipeCuisine />
                },
                {
                  path: 'recipe-keyword-list',
                  element: <AppGroxRecipeNutritionList />
                },
                {
                  path: 'add-new-recipe-Keyword',
                  element: <AppGroxAddRecipeNutrition />
                },
                {
                  path: 'recipeBanners-list',
                  element: <AppGroxRecipeBannersList />
                },
                {
                  path: 'add-new-recipeBanners',
                  element: <AppGroxAddRecipeBanners />
                },
                {
                  path: 'recipeSlider-list',
                  element: <AppGroxRecipeSlidersList />
                },
                {
                  path: 'add-new-recipeSlider',
                  element: <AppGroxAddRecipeSliders />
                }
              ]
            },
            {
              path: 'purchase',
              children: [
                {
                  path: 'purchase-list',
                  element: <AppGroxPurchaseList />
                },
                {
                  path: 'add-new-purchase',
                  element: <AppGroxAddPurchase />
                }
              ]
            },
            {
              path: 'purchase',
              children: [

                {
                  path: 'update-price',
                  element: <AppGroxUpdatePurchaseProduct />
                },
              ]
            },
            {
              path: 'purchase',
              children: [
                {
                  path: 'whole-sale-purchase-list',
                  element: <AppGroxWholeSalePurchaseList />
                },
                {
                  path: 'add-new-whole-sale-purchase',
                  element: <AppGroxAddWholeSalePurchase />
                }
              ]
            },
            {
              path: 'bees',
              children: [
                {
                  path: 'bees-list',
                  element: <AppGroxBeesList />
                },
                {
                  path: 'AddNewBees',
                  element: <AppGroxAddBees />
                }
              ]
            },
            {
              path: 'staff',
              children: [
                {
                  path: 'staff-list',
                  element: <AppGroxStaffList />
                },
                {
                  path: 'AddNewStaff',
                  element: <AppGroxAddStaff />
                }
              ]
            },
            {
              path: 'notification',
              children: [
                {
                  path: 'notification-list',
                  element: <AppGroxNotificationList />
                },
                {
                  path: 'AddNewNotification',
                  element: <AppGroxAddNotification />
                }
              ]
            },
            {
              path: 'company',
              children: [
                {
                  path: 'company-list',
                  element: <AppGroxCompanyList />
                },
                {
                  path: 'AddNewCompany',
                  element: <AppGroxAddCompany />
                },
                {
                  path: 'company-bank-list',
                  element: <AppGroxCompanyBankList />
                },
                {
                  path: 'AddBank',
                  element: <AppGroxAddBank />
                }
              ]
            },
                {
                  path: 'homeScreen',
                  children: [
                    {
                      path: 'home-components-list',
                      element: <AppGroxHomeScreenComponentList />
                    },
                    {
                      path: 'AddHomeScreenComponent',
                      element: <AppGroxAddHomeScreenComponent />
                    },
                    // {
                    //   path: 'home-components-list',
                    //   element: <AppGroxHomeScreenComponentList />
                    // },
                    {
                      path: 'homeScreen-images-list',
                      element: <AppGroxHomeScreenImageList />
                    },
                    {
                      path: 'AddHomeScreenImage',
                      element: <AppGroxAddHomeScreenImage />
                    },
                    {
                      path: 'home-components-itemList',
                      element: <AppGroxHomeComponentItemList />
                    },
                    {
                      path: 'AddNewHomeComponentItem',
                      element: <AppGroxHomeComponentItem />
                    },
                    {
                      path: 'AddComponentToLayout',
                      element: <AppGroxAddComponentToLayout />
                    },
                 
                  ]
                },
                {
                  path: 'flavor',
                  children: [
                    {
                      path: 'flavor-components-list',
                      element: <AppGroxFlavorScreenComponentList />
                    },
                    {
                      path: 'AddFlavorScreenComponent',
                      element: <AppGroxAddFlavorScreenComponent />
                    },
                    // {
                    //   path: 'home-components-list',
                    //   element: <AppGroxHomeScreenComponentList />
                    // },
                    // {
                    //   path: 'flavorScreen-images-list',
                    //   element: <AppGroxHomeScreenImageList />
                    // },
                    // {
                    //   path: 'AddHomeScreenImage',
                    //   element: <AppGroxAddHomeScreenImage />
                    // },
                    {
                      path: 'flavor-components-itemList',
                      element: <AppFlavorHomeComponentItemList />
                    },
                    {
                      path: 'AddNewFlavorComponentItem',
                      element: <AppFlavorHomeComponentItem />
                    },
                    {
                      path: 'AddFlavorComponentToLayout',
                      element: <AppFlavorAddComponentToLayout />
                    },
                 
                  ]
                },
            {
              path: 'filter',
              children: [
                {
                  path: 'filter-list',
                  element: <AppGroxFilterList />
                },
                {
                  path: 'add-new-filter',
                  element: <AppGroxAddFilter />
                },
                {
                  path: 'filterGroup-list',
                  element: <AppGroxFilterGroupList />
                },
                {
                  path: 'add-new-filterGroup',
                  element: <AppGroxAddFilterGroup />
                }
              ]
            }
          ]
        },
        {
          path: 'forms',
          children: [
            {
              path: 'validation',
              element: <FormsValidation />
            },
            {
              path: 'wizard',
              element: <FormsWizard />
            },
            {
              path: 'layout',
              children: [
                {
                  path: 'basic',
                  element: <FormsLayoutBasic />
                },
                {
                  path: 'multi-column',
                  element: <FormsLayoutMultiColumn />
                },
                {
                  path: 'action-bar',
                  element: <FormsLayoutActionBar />
                },
                {
                  path: 'sticky-bar',
                  element: <FormsLayoutStickyBar />
                }
              ]
            },
            {
              path: 'plugins',
              children: [
                {
                  path: 'mask',
                  element: <FormsPluginsMask />
                },
                {
                  path: 'clipboard',
                  element: <FormsPluginsClipboard />
                },
                {
                  path: 're-captcha',
                  element: <FormsPluginsRecaptcha />
                },
                {
                  path: 'editor',
                  element: <FormsPluginsEditor />
                },
                {
                  path: 'dropzone',
                  element: <FormsPluginsDropzone />
                }
              ]
            }
          ]
        },
        {
          path: 'tables',
          children: [
            {
              path: 'react-table',
              children: [
                {
                  path: 'basic',
                  element: <ReactTableBasic />
                },
                {
                  path: 'sorting',
                  element: <ReactTableSorting />
                },
                {
                  path: 'filtering',
                  element: <ReactTableFiltering />
                },
                {
                  path: 'grouping',
                  element: <ReactTableGrouping />
                },
                {
                  path: 'pagination',
                  element: <ReactTablePagination />
                },
                {
                  path: 'row-selection',
                  element: <ReactTableRowSelection />
                },
                {
                  path: 'expanding',
                  element: <ReactTableExpanding />
                },
                {
                  path: 'editable',
                  element: <ReactTableEditable />
                },
                {
                  path: 'drag-drop',
                  element: <ReactTableDragDrop />
                },
                {
                  path: 'column-hiding',
                  element: <ReactTableColumnHiding />
                },
                {
                  path: 'column-resizing',
                  element: <ReactTableColumnResizing />
                },
                {
                  path: 'sticky-table',
                  element: <ReactTableStickyTable />
                },
                {
                  path: 'umbrella',
                  element: <ReactTableUmbrella />
                },
                {
                  path: 'empty',
                  element: <ReactTableEmpty />
                }
              ]
            },
            {
              path: 'mui-table',
              children: [
                {
                  path: 'basic',
                  element: <MuiTableBasic />
                },
                {
                  path: 'dense',
                  element: <MuiTableDense />
                },
                {
                  path: 'enhanced',
                  element: <MuiTableEnhanced />
                },
                {
                  path: 'datatable',
                  element: <MuiTableDatatable />
                },
                {
                  path: 'custom',
                  element: <MuiTableCustom />
                },
                {
                  path: 'fixed-header',
                  element: <MuiTableFixedHeader />
                },
                {
                  path: 'collapse',
                  element: <MuiTableCollapse />
                }
              ]
            }
          ]
        },
        {
          path: 'charts',
          children: [
            {
              path: 'apexchart',
              element: <ChartApexchart />
            },
            {
              path: 'org-chart',
              element: <ChartOrganization />
            }
          ]
        },
        {
          path: 'sample-page',
          element: <SamplePage />
        },
        {
          path: 'pricing',
          element: <PricingPage />
        }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        {
          path: 'under-construction',
          element: <MaintenanceUnderConstruction />
        },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        }
      ]
    },
    {
      path: '/auth',
      element: <CommonLayout />,
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        }
      ]
    }
  ]
};

export default MainRoutes;
